var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsPrivacyPolicyBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons_privacy_policy_blue",
    "data-name": "Icons/privacy policy_blue",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_51107",
    "data-name": "Path 51107",
    d: "M15.606,18.414a.451.451,0,0,1-.177-.036C15.29,18.318,12,16.886,12,13.939V11.524a.451.451,0,0,1,.306-.427l3.155-1.073a.451.451,0,0,1,.29,0L18.906,11.1a.451.451,0,0,1,.306.427v2.415c0,2.947-3.29,4.379-3.429,4.44A.461.461,0,0,1,15.606,18.414Zm-2.7-6.567v2.091c0,2,2.077,3.207,2.7,3.525.627-.317,2.7-1.522,2.7-3.525V11.847l-2.7-.92Z",
    transform: "translate(-4.212 -3.414)",
    fill: "#03c4de"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51108",
    "data-name": "Path 51108",
    d: "M16.653,17.305a.447.447,0,0,1-.319-.132l-1.2-1.2a.451.451,0,0,1,.638-.638l.835.835L18.1,14.18a.451.451,0,1,1,.721.541l-1.8,2.4a.45.45,0,0,1-.329.179h-.031Z",
    transform: "translate(-5.409 -5.15)",
    fill: "#03c4de"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51109",
    "data-name": "Path 51109",
    d: "M6.365,13.2H1.653A1.693,1.693,0,0,1,0,11.469V1.728A1.693,1.693,0,0,1,1.653,0H8.564a1.693,1.693,0,0,1,1.653,1.728V5.141a.451.451,0,1,1-.9,0V1.728A.77.77,0,0,0,8.564.943H1.653A.77.77,0,0,0,.9,1.728v9.741a.77.77,0,0,0,.751.786H6.365a.472.472,0,0,1,0,.943Z",
    fill: "#03c4de"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51110",
    "data-name": "Path 51110",
    d: "M9.16,8.9H3.451a.451.451,0,0,1,0-.9H9.16a.451.451,0,0,1,0,.9Z",
    transform: "translate(-1.197 -2.987)",
    fill: "#03c4de"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51111",
    "data-name": "Path 51111",
    d: "M6.756,12.9H3.451a.451.451,0,1,1,0-.9H6.756a.451.451,0,1,1,0,.9Z",
    transform: "translate(-1.197 -4.481)",
    fill: "#03c4de"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_51112",
    "data-name": "Path 51112",
    d: "M6.155,4.9h-2.7a.451.451,0,1,1,0-.9h2.7a.451.451,0,1,1,0,.9Z",
    transform: "translate(-1.197 -1.494)",
    fill: "#03c4de"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPrivacyPolicyBlue);
export default __webpack_public_path__ + "static/media/icons_privacy_policy_blue.1cb915610f0548fc8a81150008e785d4.svg";
export { ForwardRef as ReactComponent };